import { m } from "@recobra/i18n/messages";
import type { NotificationInboxItem } from "@recobra/schemas/notification";

export const formatNotificationSource = (item: NotificationInboxItem): string => {
  if (item.actor?.displayName) return item.actor.displayName;
  if (item.actor?.source === "automation") return m.notifications_source_automation();
  if (item.category === "security") return m.notifications_source_security();

  return m.notifications_system_source();
};
